export default "__VITE_ASSET__CY$EYSpr__"